import React from "react";

import svg from "../../assets/images/icons/Form Controls/Date Range Picker.svg";

export const DateRangeIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Cut"}
    />
);
